// import react from 'react';

export const StringFormatter = (queryStr, queryArr) => {
    let formatted = queryStr;
  
    queryArr.forEach((arg, index) => {
      let value = arg;
  
      // same behavior: null/undefined become empty
      if (value === null || value === undefined) value = "";
  
      // ensure string
      value = String(value);
  
      // same logic: escape single quotes only
      value = value.replaceAll("'", "''");
  
      // exact same pattern you were using
      const token = "'{" + index + "}'";
      const replacement = "N'" + value + "'";
  
      // replace ONLY the placeholder, nothing else
      formatted = formatted.split(token).join(replacement);
    });
  
    return formatted;
  };

export const brTagReplacer = (str) => {
    var string = str;
    string = string.replace(/<br\s*\/?>/gi,'<br/>');
    return string;
}